module.exports = __webpack_public_path__ + "images/emoji/heavy_check_mark.da7375512d9ee7f95f1f.png";